export const BASE_URL = 'release/notes';
export const BASE_API_URL = `/api/v1`;
export const ROUTE_SERVER = '/:tag?(/page/:page)?';
export const ROUTE_CLIENT = '/:tag?*(/page/:page)?';
export const ROUTE_ARTICLE = '/article/:id';
